import type { PublicMaintenance } from "@dropl/shared";
import { api } from "../api/index.js";
import { getPublicSocket, type PublicSocket } from "../socket/index.js";
import { currentSession, setMaintenance } from "../state/session.js";

const POLL_MS = 30_000;

function userCanBypass(m: PublicMaintenance): boolean {

  if (m.bypassed) return true;
  const { user } = currentSession();
  if (!user) return false;
  const perms = user.capabilities.permissions;
  if (perms.includes("maintenance.bypass")) return true;
  if (m.allowAdmin && perms.includes("admin.access")) return true;
  return false;
}

let publicSocket: PublicSocket | null = null;

export function startMaintenanceWatcher(initial: PublicMaintenance): void {
  apply(initial);
  window.setInterval(() => { void tick(); }, POLL_MS);

  if (!publicSocket) {
    publicSocket = getPublicSocket();
    publicSocket.on("public:maintenance.updated", () => { void tick(); });
  }
}

async function tick(): Promise<void> {
  try {

    const c = await api<{ maintenance: PublicMaintenance }>("/api/config");
    apply(c.maintenance);
  } catch {

    const path = location.pathname;
    if (path !== "/maintenance" && !isWhitelisted(path)) {
      location.href = "/maintenance";
    }
  }
}

function isWhitelisted(path: string): boolean {
  if (path === "/maintenance") return true;
  if (path === "/login") return true;
  if (path === "/forgot-password") return true;
  if (path.startsWith("/auth/")) return true;
  if (path.startsWith("/legal")) return true;
  if (path.startsWith("/admin")) return true;
  return false;
}

function apply(m: PublicMaintenance): void {

  setMaintenance(m);

  const path = location.pathname;
  const onPage = path === "/maintenance";

  if (m.enabled && !userCanBypass(m)) {

    if (onPage || isWhitelisted(path)) return;
    location.href = "/maintenance";
    return;
  }

  if (onPage) location.href = "/";
}
